<template>
  <CloudWordBox :cloudOptions="cloudOptions" />
</template>

<script>
import CloudWordBox from "../../components/CloudWordBox/CloudWordBox.vue";

export default {
  name: "app",
  components: {
    CloudWordBox
  },
  data() {
    return {
      cloudOptions: JSON.parse(this.$options._parentVnode.data.props.cloudOptions),
    };
  }
};
</script>
